import React from 'react'
import { UpsellingEntity } from 'services/api/entities'
import CustomReferenceInput from 'ui-shared/CustomInputs/CustomReferenceInput'
import LocalizedSelectArrayInput from 'ui-shared/LocalizedFields/LocalizedSelectArrayInput'

export type UpsellingSelectorProps = {
  upsellingEntity: UpsellingEntity
}

const UpsellingSelector: React.FC<UpsellingSelectorProps> = ({
  upsellingEntity,
}) => (
  <CustomReferenceInput entity={upsellingEntity}>
    <LocalizedSelectArrayInput
      source="upsellingItems"
      label="Upselling Items"
      fullWidth
    />
  </CustomReferenceInput>
)

export default UpsellingSelector
